module.exports = __webpack_public_path__ + "img/xitong.c8826f7e.png";